"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
const core_1 = require("@angular/core");
const http_1 = require("@angular/http");
const serviceAuthentication_1 = require("./serviceAuthentication");
const IInaxConfigService_interface_1 = require("../interfaces/IInaxConfigService.interface");
const guid_1 = require("../guid");
class ChangeSubscriber {
    constructor(callback) {
        this.callback = callback;
        this.id = guid_1.Guid.newGuid();
    }
}
let ProfileService = class ProfileService {
    constructor(_http, _configurationService) {
        this._http = _http;
        this._configurationService = _configurationService;
        this._authData = null;
        this._subscribers = [];
        this._authData = JSON.parse(localStorage.getItem('auth_token'));
        this._configSubscription = _configurationService
            .getConfiguration()
            .subscribe((configSettings) => {
            this._configuration = _configurationService;
            this.login(this._configuration.Username, this._configuration.Password)
                .subscribe((result) => {
                if (result) {
                    this._subscribers.forEach(sub => {
                        try {
                            sub.callback();
                        }
                        catch (error) {
                            console.error(error);
                        }
                    });
                }
            });
        });
    }
    addSubscriber(callback) {
        let sub = new ChangeSubscriber(callback);
        this._subscribers.push(sub);
        return sub.id;
    }
    removeSubscriber(id) {
        let idx = this._subscribers.findIndex(s => s.id === id);
        if (idx >= 0) {
            this._subscribers.splice(idx, 1);
        }
    }
    isAuthenticated() {
        return this._authData != null && this._authData.Authenticated && new Date(this._authData.TokenExpires) > new Date();
    }
    roles() {
        return this._authData != null && this._authData.Authenticated ? this._authData.Roles : new Array();
    }
    addAuthorization(headers) {
        this.ensureAuthenticated();
        headers.append('Content-Type', 'application/json');
        let authToken = JSON.parse(localStorage.getItem('auth_token'));
        headers.append('Authorization', `Bearer ${authToken.Token}`);
        return headers;
    }
    getUserInfo() {
        let url = this._configuration.buildRestUrl("Account", "Logon");
        let headers = this.addAuthorization(new http_1.Headers());
        return this._http.get(url, { headers: headers }).map(res => res.json());
    }
    getToken() {
        try {
            let authToken = localStorage.getItem('auth_token');
            return JSON.parse(authToken).Token;
        }
        catch (error) {
            console.warn("invald authentication token!");
        }
        return null;
    }
    ensureAuthenticated(throwException = false) {
        let loggedIn = false;
        try {
            if (this._authData != null) {
                loggedIn = ((new Date(this._authData.TokenExpires).valueOf() - Date.now().valueOf()) > 0);
            }
            else {
                var token = localStorage.getItem('auth_token');
                if (token != null) {
                    this._authData = JSON.parse(token);
                    loggedIn = ((new Date(this._authData.TokenExpires).valueOf() - Date.now().valueOf()) > 0);
                }
            }
        }
        catch (error) {
            console.warn(error);
            this._authData = null;
        }
        if (throwException && !loggedIn)
            throw "not authenticated";
        return loggedIn;
    }
    login(username, password) {
        let url = this._configuration.Url + "token";
        let headers = new http_1.Headers();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        let data = "grant_type=password&username=" + username + "&password=" + password;
        return this._http
            .post(url, data, { headers })
            .map(res => res.json())
            .map((result) => {
            try {
                if (result != null) {
                    this._authData = new serviceAuthentication_1.ServiceAuthentication;
                    this._authData.UserName = result.userName;
                    this._authData.UserRetreived = false;
                    this._authData.Token = result.access_token;
                    this._authData.TokenExpires = result[".expires"];
                    this._authData.Authenticated = new Date(this._authData.TokenExpires) > new Date();
                    if (this._authData.Authenticated) {
                        localStorage.setItem('auth_token', JSON.stringify(this._authData));
                        console.warn("Authenticated!");
                        return true;
                    }
                    else {
                        localStorage.removeItem('auth_token');
                        console.warn("Not Authenticated!");
                        return false;
                    }
                }
                else {
                    console.warn("Not Authenticated!");
                    return false;
                }
            }
            catch (error) {
                localStorage.removeItem('auth_token');
                console.warn(error);
                return false;
            }
        });
    }
    logout() {
        let url = this._configuration.buildRestUrl("Account", "Logout");
        if (this._authData != null)
            this._authData.Authenticated = false;
        return this._http.post(url, null).map(res => res.json()).subscribe(res => {
            localStorage.removeItem('auth_token');
        });
    }
    UnauthorizedResult() {
        this.logout();
    }
};
ProfileService = __decorate([
    core_1.Injectable(),
    __param(1, core_1.Inject(IInaxConfigService_interface_1.IINAXCONFIGSERVICE_TOKEN)),
    __metadata("design:paramtypes", [http_1.Http, Object])
], ProfileService);
exports.ProfileService = ProfileService;
